export default {"src":"/_next/static/media/icon_thumbs_clicked.a1c9cff9.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};